import { __extends } from "tslib";
import { StartCelebrityRecognitionRequest, StartCelebrityRecognitionResponse } from "../models/index";
import { deserializeAws_json1_1StartCelebrityRecognitionCommand, serializeAws_json1_1StartCelebrityRecognitionCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var StartCelebrityRecognitionCommand = /** @class */ (function (_super) {
    __extends(StartCelebrityRecognitionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StartCelebrityRecognitionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    StartCelebrityRecognitionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: StartCelebrityRecognitionRequest.filterSensitiveLog,
            outputFilterSensitiveLog: StartCelebrityRecognitionResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StartCelebrityRecognitionCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1StartCelebrityRecognitionCommand(input, context);
    };
    StartCelebrityRecognitionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1StartCelebrityRecognitionCommand(output, context);
    };
    return StartCelebrityRecognitionCommand;
}($Command));
export { StartCelebrityRecognitionCommand };
//# sourceMappingURL=StartCelebrityRecognitionCommand.js.map